<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <!-- table format-->
    <div class="col-lg-12">
      <div class="page-breadcrumb"><!-- new -->
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a *ngIf="this.loginPersonType == 'EMPLOYEE'">Material</a><a
            *ngIf="this.loginPersonType != 'EMPLOYEE'">Inventory Control</a></li>
          <li><a *ngIf="this.loginPersonType == 'EMPLOYEE'">Vendor Master</a><a
            *ngIf="this.loginPersonType != 'EMPLOYEE'">Vendors</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <div class="panel">
        <div class="screen_heading_div">
          <span>Vendors</span>
          <img src="../../../../../../assets/images/New_Icons/refresh.svg" title="Refresh" (click)="ngOnInit()">
        </div>
        <div class="search_cum_icons_button_container">
          <div class="search-div">
            <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
            <input type="text" (keyup)="applySearch()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by main fields">
          </div>
        </div>
        <div *ngIf="!responseLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="table-responsive" style="padding: 0 30px;" *ngIf="responseLoader">
          <table class="table table-striped" cellspacing=" 0" width="100%">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Vendor name</th>
                <th>Vendor Site</th>
                <th *ngIf="loginPersonType == 'EMPLOYEE'">Business</th>
                <th>Pincode</th>
                <th>City</th>
                <th>State</th>
                <th>Contact No</th>
                <th>GST No</th>
                <th></th>
                <th></th>
              </tr>
              <tr>
                <td id="newrecordid"><span (click)="addVendorMasterIcon()" class="addbtnitemmaster">
                  <img src="assets/images/New_Icons/plus-icon.svg" title="Add Vendor"></span></td>
                <td><input type="text" name="vendorname" class="form-control textField" [(ngModel)]="vendor.name"
                           autocomplete="off" (keypress)="alphabetsValidation($event)"></td>
                <td><input type="text" name="vendorsite" class="form-control textField" [(ngModel)]="vendor.site"
                           autocomplete="off" (keypress)="alphabetsValidation($event)"></td>
                <td>
                  <div *ngIf="loginPersonType == 'EMPLOYEE'">
                  <mat-form-field appearance="outline" class="w-100" *ngIf="loginPersonType==='EMPLOYEE'" style="height: 50px;">
                    <mat-label>Business Name</mat-label>

                    <input matInput
                          [formControl]="businessCtrl"
                          [matAutocomplete]="businessAuto"
                          autocomplete="off"
                          placeholder="Search business"
                          (keyup)="filterBusinesses()"
                          (focus)="filteredBusinesses = businessEntities">

                    <mat-autocomplete #businessAuto="matAutocomplete"
                                      [displayWith]="displayBusiness"
                                      (optionSelected)="selectOption($event.option.value)">
                      
                      <mat-option *ngFor="let option of filteredBusinesses" [value]="option">
                        {{ option.businessName }}
                      </mat-option>

                    </mat-autocomplete>

                  </mat-form-field>
                  </div>
                  <p style="border: 1px solid #ccc; padding: 7px; border-radius: 4px;margin-top: 12px;"
                     [ngClass]="!hideBusinessDetailsBlock ? 'disbledCls' : ''"
                     *ngIf="loginPersonType != 'EMPLOYEE'">{{loginUserBusinessName}}</p>
                </td>
                <td><input type="text" class="form-control textField" name="pincode" [(ngModel)]="vendor.postal_code"
                           autocomplete="off" (keypress)="numberValidation($event)"></td>
                <td><input name="city" class="form-control textField" type="text" [(ngModel)]="vendor.city" autocomplete="off"
                           (keypress)="alphabetsValidation($event)"></td>
                <td><input name="state" class="form-control textField" type="text" [(ngModel)]="vendor.state" autocomplete="off"
                           (keypress)="alphabetsValidation($event)">
                </td>
                <td><input name="contactno" class="form-control textField" type="text" [(ngModel)]="vendor.contact"
                           (keypress)="numberValidation($event)"></td>
                <td><input name="gstno" class="form-control textField" type="text" [(ngModel)]="vendor.GST_No" autocomplete="off">
                </td>
                <td (click)="vendorMasterFormSubmit()" title="Save Vendor"
                    class="savebtn" [style.cursor]="addVendorDoubleClick ? 'not-allowed':'pointer'">
                  <i class="fa fa-floppy-o" aria-hidden="true"></i></td>
              </tr>
            </thead>
            <tbody *ngIf="responseLoader">
              <tr class="searchfun" *ngFor="let list of vendorsList; let i = index">
              <td>{{i+1}}</td>
              <td>{{ list && list.name ? list.name : 'NA' }}</td>
              <td>{{ list && list.site ? list.site : 'NA' }}</td>
              <td
                *ngIf="loginPersonType == 'EMPLOYEE'">{{ list && list.business.length > 0 && list && list.business[0].businessName ? list.business[0].businessName : 'NA' }}
              </td>
              <td>{{ list && list.postal_code ? list.postal_code : 'NA' }}</td>
              <td>{{ list && list.city ? list.city : 'NA' }}</td>
              <td>{{ list && list.state ? list.state : 'NA' }}</td>
              <td>{{ list && list.contact ? list.contact : 'NA' }}</td>
              <td>{{ list && list.GST_No ? list.GST_No : 'NA' }}</td>
              <td class="editicon itemtypeleftRecCls" title="Edit Vendor"><span><img
                src="assets/images/New_Icons/edit.svg" (click)="editVendormasterIcon(list)" class="edit-vendor">
                </span>
              </td>
              <!--<td class="editicon itemtypeleftRecCls" data-toggle="tooltip"
                  data-placement="bottom" title="Delete Vendor"><span  class="delete-vendor"><img src="assets/images/New_Icons/delete-icon.svg"></span>
              </td>-->
            </tr>
            </tbody>
          </table>
          <div *ngIf="listLoader" class="loader-div">
            <div class="adjust">
              <div class="loader2 list-loader"></div>
            </div>
          </div>
          <div *ngIf="noList && responseLoader" class="noDataFoundMessage">No Data Available</div>
        </div>
      </div>
    </div>
  </div>
</div>
